import React from 'react'
import { Outlet } from 'react-router-dom'

export const PaymentAgent: React.FC = () => {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  )
}
